import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, dark = false }) => (
  <div className="flex items-center gap-3">
    <span className="h-px w-8" style={{ background: "#C8A75D" }} />
    <span
      className="text-xs font-bold uppercase tracking-[0.22em]"
      style={{ color: dark ? "#C8A75D" : "#C8A75D" }}
    >
      {children}
    </span>
  </div>
);

export const CTA = ({ href, children, variant = "primary", testId, className = "" }) => {
  const base =
    "inline-flex items-center justify-center gap-2 rounded-full px-7 py-3.5 text-sm font-semibold tracking-tight transition-colors duration-300 ease-out";
  const styles =
    variant === "primary"
      ? "bg-[#0B1F3A] text-white hover:bg-[#C8A75D] hover:text-[#0B1F3A]"
      : variant === "gold"
      ? "bg-[#C8A75D] text-[#0B1F3A] hover:bg-white"
      : variant === "ghost-dark"
      ? "border border-white/25 text-white hover:border-[#C8A75D] hover:text-[#C8A75D]"
      : "border border-[#0B1F3A]/20 text-[#0B1F3A] hover:border-[#0B1F3A] hover:bg-[#0B1F3A] hover:text-white";
  return (
    <a
      href={href}
      target={href?.startsWith("http") ? "_blank" : undefined}
      rel={href?.startsWith("http") ? "noopener noreferrer" : undefined}
      data-testid={testId}
      className={`${base} ${styles} ${className}`}
    >
      {children}
    </a>
  );
};
